<template>
  <v-row class="ma-0" align="center" justify="center">
    <v-col align="center" :class="isAdminSignIn ? '' : 'mt-10'">
      <p class="text-h5 mt-3 text-center" v-if="isAdminSignIn">管理者ログイン</p>
      <v-card class="signin-card pa-10 elevation-10">
        <div class="text-center">
          <img class="logo" src="@/assets/img/logo.png" alt="ゲットスルー">
        </div>
        <v-form ref="form" @submit.prevent>
          <v-card-text class="mt-6 text-center">
            <v-text-field
              label="Login ID"
              name="login"
              prepend-icon="mdi-account"
              type="text"
              v-model="login"
            ></v-text-field>

            <v-text-field
              id="password"
              label="Password"
              name="password"
              prepend-icon="mdi-lock"
              type="password"
              v-model="password"
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="signin-btn__area">
            <v-btn
              rounded
              block
              color="secondary"
              class="signin-btn"
              @click="signIn"
              type="submit"
              :disabled="!activateSubmit"
            >
              ログイン
            </v-btn>
          </v-card-actions>
        </v-form>
        <p class="env-text mb-0">ブラウザは、WindowsはEdgeまたは<br>Chrome、MacはSafariをご利用ください</p>
      </v-card>

      <!-- 動作環境ページ -->
      <router-link
        class="mt-8 env-check__link"
        to="/env_check"
        target="_blank"
        v-if="!isAdminSignIn"
      >
        動作環境ページ
      </router-link>

      <!-- パスワード再発行ページ -->
      <router-link
        class="mt-2 env-check__link"
        to="/lost_password"
        v-if="!isAdminSignIn"
      >
        パスワードを忘れた方はこちら
      </router-link>

      <!-- Cookie等の取り扱いについてページ -->
      <a
        class="mt-2 env-check__link"
        href="https://www.e-network.jp/company/privacy_cookie2.html"
        target="_blank"
        v-if="!isAdminSignIn"
      >
        Cookie等の取り扱いについて
      </a>

      <!-- お知らせ -->
      <v-col md=5 sm=9 class="mt-5" v-if="!isAdminSignIn">
        <v-notification showAreaType="login" defaultSize=2 />
      </v-col>
    </v-col>
  </v-row>
</template>

<script>
import VNotification from '@/components/molecules/Notification'

export default {
  components: {
    VNotification
  },
  computed: {
    // ログインボタンの活性非活性化
    activateSubmit() {
      return this.login !== '' && this.password !== ''
    },
    // 管理者ログイン用ページであるか
    isAdminSignIn() {
      return this.$route.path.includes('/admin')
    }
  },
  data () {
    return {
      login: '',
      password: '',
    }
  },
  mounted() {
    // sessionにconditionsを初期化
    this.$store.commit('conditions/initialize')
    // ログイン中と判断される値を初期化
    this.$store.commit('user/logout', {})
  },
  methods: {
    // ログインAPI実行処理
    async signIn() {
      const res = await this.$axios.post('/api/v1/auth/sign_in', {
        login: this.login,
        password: this.password,
      })
      //ユーザーログイン画面から管理者アカウントでログインしようとしたら認証エラー扱いとして遷移しない
      if(!this.isAdminSignIn && res.data.type==='Admin' || this.isAdminSignIn && res.data.type==='Teacher' ) {
        this.$toasted.global.error({ message: 'ログイン認証情報が正しくありません。再度お試しください。' })
        return
      }

      // 成功時の処理
      // レスポンスヘッダーから認証情報を取得
      const auth = {
        accessToken: res.headers['access-token'],
        client:      res.headers['client'],
        uid:         res.headers['uid'],
      }
      // 認証情報とログイン情報をstoreに格納
      const payload = Object.assign(auth, res.data)
      this.$store.commit('user/login', payload)
      this.$store.commit('user/setRole', { role: res.data.type })
      this.$store.commit('user/setLastOperatedDate', { lastOperatedDate: new Date })
      // axiosのヘッダーにログイン情報設定
      const strageData = JSON.parse(sessionStorage.getItem('ENGetThrough'));
      this.$axios.defaults.headers.common['access-token'] = strageData.user.accessToken;
      this.$axios.defaults.headers.common['client']       = strageData.user.client;
      this.$axios.defaults.headers.common['uid']          = strageData.user.uid;
      // マスタデータ取得
      await this.$store.dispatch('master/getMasterData')
      //単元とテーマのマスタをセット
      this.$store.commit('conditions/setMasterQuestionRangeTangen', {
        allUnits: this.$store.state.master.allUnits
      })
      this.$store.commit('conditions/setMasterQuestionRangeTheme', {
        allThemes: this.$store.state.master.allThemes
      })

      // Teacherアカウントで規約未同意だったら同意画面へ遷移
      if (res.data.type === 'Teacher' && !res.data.agreed) {
        this.$router.push('teacher/agreed')
        return
      }
      // ログインアカウントによって遷移先を振り分ける（管理者・先生）
      this.$router.push(this.$store.getters['user/homePath'])
    },
  }
}
</script>

<style lang="stylus">
.v-input__slot
  min-height 40px !important
  margin-bottom 4px !important
.v-text-field__details
  background-color white !important
  margin-bottom 8px !important
  padding 0px 12px !important
</style>

<style lang="stylus" scoped>
.row
  height 100%

.signin
  &-card
    height 490px
    width 371px

  &-btn
    color white !important
    margin-top 50px

    &__area
      margin-bottom 30px
      height 70px

button:enabled
  background-image linear-gradient(to bottom, #10318b, #55669b 30%, #2b3555)

.env-text
  font-size 12px
  position absolute
  right 0px
  width 371px
  padding 0px 5px
  color #646464

.env-check__link
  display block
  color #165297

</style>
